export default function Empty() {
    return <p className="text-center">Wow, such emptiness!</p>;
}
